import React from 'react';
import { GraduationCap, Mail } from 'lucide-react';
import { profileData } from '../../data/profileData';
import { GitHubIcon, Icon, LinkedInIcon } from '../ui';
import './Footer.css';

const Footer: React.FC = () => {
  const { basicInfo, navigation } = profileData;
  const socials = [
    { label: 'LinkedIn', href: basicInfo.linkedIn, icon: <LinkedInIcon size={18} />, external: true },
    { label: 'GitHub', href: basicInfo.github, icon: <GitHubIcon size={18} />, external: true },
    { label: 'Email', href: `mailto:${basicInfo.email}`, icon: <Icon icon={Mail} size={18} />, external: false },
    { label: 'Academic e-portfolio', href: basicInfo.ePortfolio, icon: <Icon icon={GraduationCap} size={18} />, external: true },
  ];

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <p className="footer__name">{basicInfo.name}</p>
          <p className="footer__title">{basicInfo.title}</p>
        </div>

        <nav className="footer__nav" aria-label="Footer">
          <ul>
            {navigation.map((item) => (
              <li key={item.id}>
                <a href={`#${item.id}`}>{item.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <ul className="footer__social" aria-label="Profiles">
          {socials.map((social) => (
            <li key={social.label}>
              <a
                href={social.href}
                aria-label={social.label}
                title={social.label}
                {...(social.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                {social.icon}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <p className="footer__copyright">
        &copy; {new Date().getFullYear()} {basicInfo.name}. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
